import { render, staticRenderFns } from "./OweStatisManage.vue?vue&type=template&id=27e2fc82&"
import script from "./OweStatisManage.vue?vue&type=script&lang=js&"
export * from "./OweStatisManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports